import reel1 from "@/assets/reel-1.mp4.asset.json";
import reel2 from "@/assets/reel-2.mp4.asset.json";
import kTipNew from "@/assets/k-tip-new.png.asset.json";
import celinaResultNew from "@/assets/celina-collection-result-new.png.asset.json";
import celinaWeftsNew from "@/assets/celina-collection-wefts-new.png.asset.json";
import { MEDIA, type MediaImage } from "@/lib/media";

const uploadedImage = (src: string, width: number, height: number): MediaImage => ({
  src,
  width,
  height,
  srcSetAvif: "",
  srcSetWebp: "",
});

export const PHOTO_BLOWOUT = MEDIA.photo9;
export const PHOTO_DARK_LAYERS = MEDIA.photo10;
export const PHOTO_BEHIND_SCENES = MEDIA.photo11;
export const PHOTO_COPPER_WAVES = MEDIA.photo12;
export const CELINA_LOGO = MEDIA.celinaLogo;
export const CELINA_LOGO_SRC = CELINA_LOGO.src;
export const PHOTO_CELINA_WEFTS = uploadedImage(celinaWeftsNew.url, 471, 1024);
export const PHOTO_CELINA_RESULT = uploadedImage(celinaResultNew.url, 768, 1024);
export const PHOTO_HIDDEN_ROW = MEDIA.hiddenRow;
export const REELS = [
  {
    src: reel1.url,
    caption: "Extension application, start to finish",
    captionsSrc: "/captions/reel-1.vtt",
  },
  {
    src: reel2.url,
    caption: "Fresh blowout in the chair",
    captionsSrc: "/captions/reel-2.vtt",
  },
];

export const SITE_URL = "https://theglamroom1111.com";

export function absoluteUrl(path: string) {
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export const LOGO = MEDIA.glamLogo;
export const LOGO_SRC = LOGO.src;
export const PHOTO_GUESTS = MEDIA.photo1;
export const PHOTO_WAITING = MEDIA.photo3;
export const PHOTO_STOREFRONT = MEDIA.photo4;
export const PHOTO_SALON_FLOOR = MEDIA.photo5;
export const PHOTO_KTIP_ORIGINAL = MEDIA.photo6;
export const PHOTO_KTIP = uploadedImage(kTipNew.url, 1272, 1672);
export const PHOTO_WAVES = MEDIA.photo7;
export const PHOTO_SILVER_BOB = MEDIA.photo8;

export const BOOKING_URL = "https://www.joinblvd.com/b/theglamroom1111/widget#/visit-type";
export const CELINA_BOOKING_URL =
  "https://www.joinblvd.com/b/theglamroom1111/widget#/cart/menu/Hair%20Extensions";
export const PHONE_DISPLAY = "(561) 855-7493";
export const PHONE_HREF = "tel:+15618557493";
export const EMAIL = "ccaban22@gmail.com";
export const PLAZA_NAME = "Town Commons Plaza";
export const ADDRESS_LINE = "8961 Hypoluxo Rd, Wellington, FL 33467";
export const ADDRESS_WITH_PLAZA = `${ADDRESS_LINE} · ${PLAZA_NAME}`;
export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=8961+Hypoluxo+Rd+Wellington+FL+33467";
export const DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=8961+Hypoluxo+Rd+Wellington+FL+33467";
export const MAP_EMBED_URL =
  "https://www.google.com/maps?q=8961+Hypoluxo+Rd,+Wellington,+FL+33467&output=embed";
export const GOOGLE_REVIEWS_URL = "https://share.google/wdcbv15W8rUApkRHc";
export const INSTAGRAM_URL = "https://www.instagram.com/theglamroom_wpb/";
export const TIKTOK_URL = "https://www.tiktok.com/@theglamroom_wpb";

export const NAV_LINKS: { label: string; href: string; external?: boolean }[] = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "The Celina Collection", href: CELINA_BOOKING_URL, external: true },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export const HOURS = [
  { day: "Tuesday", time: "10:00am – 7:00pm" },
  { day: "Wednesday", time: "9:00am – 5:00pm" },
  { day: "Thursday", time: "10:00am – 7:00pm" },
  { day: "Friday", time: "9:00am – 5:00pm" },
  { day: "Saturday", time: "9:00am – 5:00pm" },
  { day: "Sunday", time: "Closed" },
  { day: "Monday", time: "Closed" },
];

export const EXTENSION_METHODS: {
  name: string;
  blurb: string;
  image: MediaImage;
  imageAlt: string;
}[] = [
  {
    name: "K-Tip",
    blurb: "Keratin bonds for a seamless, long-wearing result on fine to medium hair.",
    image: PHOTO_KTIP,
    imageAlt: "K-tip keratin bonds being applied to brown hair",
  },
  {
    name: "I-Tip",
    blurb: "No heat, no glue — beaded strands that move naturally and are easy to maintain.",
    image: PHOTO_KTIP_ORIGINAL,
    imageAlt: "I-tip extensions being applied to brown hair",
  },
  {
    name: "Volume Weft",
    blurb: "Lightweight wefts that add serious fullness without weighing the hair down.",
    image: PHOTO_WAVES,
    imageAlt: "Voluminous dark waves created with volume weft extensions",
  },
  {
    name: "Tape-In",
    blurb: "Fast to apply and gentle on the hair — ideal for a first-time extension guest.",
    image: PHOTO_BLOWOUT,
    imageAlt: "Bronde layered blowout finished with tape-in extensions",
  },
  {
    name: "Hidden Row Method",
    blurb:
      "A discreet weft tucked under a natural section — invisible at the part, with movement that looks entirely your own.",
    // Placeholder until a dedicated client photo is swapped in.
    image: PHOTO_HIDDEN_ROW,
    imageAlt: "Hidden row weft tucked beneath a natural section of dark wavy hair",
  },
];

export const SERVICES = [
  {
    name: "Hair Extensions",
    blurb: "Five methods, custom color-matched and applied for length, volume, or both.",
    featured: true,
  },
  { name: "Haircuts", blurb: "Precision cuts shaped to your texture, lifestyle, and routine." },
  {
    name: "Conditioning Treatments",
    blurb: "Restorative in-salon treatments for softness, shine, and strength.",
  },
  { name: "Blowouts", blurb: "Smooth, bouncy, event-ready hair that lasts for days." },
  {
    name: "Up Styles & Half-Up Styles",
    blurb: "Weddings, galas, and every occasion in between — styled to last all night.",
  },
  { name: "Full Color", blurb: "Rich, dimensional all-over color with a flawless grow-out." },
  { name: "Highlights", blurb: "Hand-placed brightness that flatters your natural tone." },
  { name: "Balayage", blurb: "Soft, sun-kissed painting for a lived-in, low-maintenance look." },
];

export const PACKAGES = [
  {
    name: "Hair Extension Packages",
    blurb:
      "Consultation, hair, application, and your first maintenance visit bundled together so your investment is cared for from day one.",
  },
  {
    name: "Color Packages",
    blurb:
      "Color paired with the treatments and finishing that keep tone true and hair healthy between visits.",
  },
  {
    name: "Balayage Packages",
    blurb:
      "Your painting service with toning and a glossing refresh, timed to keep your blend soft all season.",
  },
];

export const REVIEWS = [
  {
    quote:
      "I had such an amazing experience at this salon. From the moment I walked in, everyone was so welcoming and professional. My shampoo was incredibly relaxing, my color came out absolutely beautiful, and my blowout was flawless. They really took their time to make sure everything was perfect, and I left feeling so confident and refreshed. The attention to detail and quality of service truly exceeded my expectations. I highly recommend this salon to anyone looking for talented stylists and an overall wonderful experience. I can\u2019t wait to come back.",
    name: "Google Review",
  },
  {
    quote:
      "I am so glad I found The Glam Room! I moved to Florida a few years ago and have been searching everywhere from Boca to Palm Beach for a salon that felt like the right fit. Little did I know, the perfect place was right in my own backyard the whole time. Celina, the owner, is absolutely amazing. She truly listens to what you want, takes her time, and her work speaks for itself. This is honestly the best my hair has ever looked, and I couldn\u2019t be happier with the results. The salon itself is adorable, welcoming, and such a cute space. I highly recommend The Glam Room to anyone looking for a talented stylist and a great experience. I finally found my forever salon.",
    name: "Google Review",
  },
  {
    quote:
      "I had such a great experience at this salon. Delilah was wonderful \u2014 incredibly detail-oriented with every highlight, and she really listened. I mentioned that I\u2019d been doing my hair at home for years and hadn\u2019t had a proper wash in a long time, and she absolutely made up for it. My champagne blonde came out exactly the way I imagined. It really feels like I\u2019ve found my new salon!",
    name: "Google Review",
  },
  {
    quote:
      "Had a great experience first time coming here! The atmosphere is relaxing & calm. All the girls are welcoming & so kind! Nicole did my hair color & blowdry, she did amazing! I was hesitant at first but she made me feel comfortable & beautiful.",
    name: "Google Review",
  },
];

export const GALLERY: { image: MediaImage; alt: string }[] = [
  {
    image: PHOTO_GUESTS,
    alt: "Three guests showing off long, wavy blonde and brunette hair at The Glam Room",
  },
  {
    image: PHOTO_SALON_FLOOR,
    alt: "The Glam Room salon floor with white styling stations and gold-framed mirrors",
  },
  {
    image: PHOTO_WAITING,
    alt: "The salon waiting area with a pink sofa, wicker chairs, and a neon sign",
  },
  { image: PHOTO_KTIP, alt: "Close-up of K-tip hair extensions being applied to brown hair" },
  {
    image: PHOTO_WAVES,
    alt: "Back view of long, voluminous dark wavy hair styled with extensions",
  },
  {
    image: PHOTO_STOREFRONT,
    alt: "The Glam Room storefront with its blue arched facade and wooden benches",
  },
  { image: PHOTO_BLOWOUT, alt: "Bronde dimensional highlights with a bouncy layered blowout" },
  {
    image: PHOTO_DARK_LAYERS,
    alt: "Long dark brunette layers styled in soft waves in the salon lounge",
  },
  { image: PHOTO_COPPER_WAVES, alt: "Copper-brown beach waves under the salon chandelier" },
  { image: PHOTO_BEHIND_SCENES, alt: "Behind the scenes: photographing a finished blonde balayage" },
];
